import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Modal, notification, Row, Select, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import { getCurrentPlanPeriodOpen, getOrgTree } from 'app/entities/common/common.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { Container } from 'reactstrap';
import { exportExcelOneReportWithMultipleOrg } from '../../objective.reducer';
import { getSelectBox, reset } from 'app/entities/category-report/category-report.reducer';
import { exportExcel } from 'app/entities/evaluation-level/evaluation-level.reducer';

type IExportExcelProps = {
    isOpen: boolean;
    onClose: () => void;
};

const formatTypes = [
    {
        value: 1,
        label: 'Excel',
    },
];

const options = [
    {
        value: 0,
        label: 'Theo lĩnh vực',
    },
    {
        value: 1,
        label: 'Theo dự án',
    },
    {
        value: 2,
        label: 'Theo mảng công việc',
    },
];


export const ExportExcelComponent = ({ isOpen, onClose }: IExportExcelProps) => {
    const dispatch = useAppDispatch();
    const tree = useAppSelector(state => state.common.orgsTree);
    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const categoryReportList = useAppSelector(state => state.categoryReport.options);
    const currentPlanPeriod = useAppSelector(state => state.common.currentPlanPeriod);

    const [isLoading, setLoading] = useState(true)
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [orgSelected, setOrgSelected] = useState<any[]>([]);
    const [categoryReportType, setCategoryReportType] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        handleGetTreeOrg();
        handleGetReportSchedule();
        dispatch(getCurrentPlanPeriodOpen());
    }, [])

    const columns = [
        {
            title: 'Tên đơn vị',
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: 'Phân loại mục tiêu / công việc trong báo cáo',
            key: 'scopeOfOperationType',
            width: 300,
            render(__, record) {
                return record.id && (
                    <Select
                        size='large'
                        className='w-100'
                        options={options}
                        placeholder="Chọn phân loại"
                        onChange={(value) => handleSelectChange(value, record.key)}
                    />
                );
            }
        },
        {
            title: 'Kèm báo cáo công việc',
            key: 'reportWork',
            width: 200,
            render(__, record, index) {
                return record.id && (
                    <div className='text-center'>
                        <Checkbox
                            onChange={(e) => handleCheckboxChange(e.target.checked, record.key)}
                        />
                    </div>
                );
            }
        },
    ];

    const handleGetTreeOrg = () => {
        dispatch(getOrgTree()).finally(() => { setLoading(false) });
    }

    const handleGetReportSchedule = () => {
        dispatch(getPlanPeriods({}));
    }

    const handleExport = (values) => {
        setLoading(true)
        if (categoryReportType === 14) {
            dispatch(
                exportExcel({ ownerId: values.reports[0].orgId, reportScheduleId: currentPlanPeriod?.value, scopeOfOperationType: values.reports[0].scopeOfOperationType })).then(res => {
                    if (res.payload) {
                        const resultExcel = res.payload as any;
                        if (resultExcel.data) {
                            saveAs(
                                new Blob([resultExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                                `Kết quả_${dayjs().format('DDMMYYYYhhmmss')}`,
                            );
                            handleClose();
                        }
                    }
                }).finally(() => { setLoading(false) });
        }
        else {
            dispatch(
                exportExcelOneReportWithMultipleOrg(values)).then(res => {
                    if (res.payload) {
                        const resultExcel = res.payload as any;
                        saveAs(
                            new Blob([resultExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                            `Báo cáo_${dayjs().format('DDMMYYYYhhmmss')}`,
                        );
                        handleClose();
                    }
                }).finally(() => { setLoading(false) });
        }
    }

    const handleClose = () => {
        onClose();
    };

    const handleSubmit = values => {
        const hasOrgId = orgSelected.some(item => item && item.orgId !== null && item.orgId !== undefined);

        if (!hasOrgId) {
            notification.warning({ message: 'Vui lòng chọn ít nhất 1 đơn vị', placement: 'topLeft' });
            return;
        }
        const payload = {
            ...values,
            reports: _.filter(orgSelected, (o) => { return o !== null && o !== undefined && o.orgId !== null && o.orgId !== undefined })
        }
        handleExport(payload)
    }

    const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
        // Update form values based on the checkbox state and index
        const updatedOrgSelected = [...orgSelected];
        newSelectedRows.map(row => {
            const indexRow = flattenTreeData(tree).findIndex(item => item.key === row.key);
            updatedOrgSelected[indexRow] = {
                ...orgSelected[indexRow],
                orgId: row.id,
                orgShortName: row.shortName
            }
        });
        setOrgSelected(updatedOrgSelected);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        getCheckboxProps: (record) => ({
            style: { display: !record.id && 'none' }, // Hide checkbox if there is no ID
        }),
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const handleSelectChange = (value, key) => {
        // Update form values based on the selected value and index
        const updatedOrgSelected = [...orgSelected];
        const indexRow = flattenTreeData(tree).findIndex(item => item.key === key);
        updatedOrgSelected[indexRow] = {
            ...updatedOrgSelected[indexRow],
            scopeOfOperationType: value,
        };
        setOrgSelected(updatedOrgSelected);
    };

    const handleCheckboxChange = (checked, key) => {
        // Update form values based on the checkbox state and index
        const updatedOrgSelected = [...orgSelected];
        const indexRow = flattenTreeData(tree).findIndex(item => item.key === key);
        updatedOrgSelected[indexRow] = {
            ...updatedOrgSelected[indexRow],
            reportWork: checked,
        };
        setOrgSelected(updatedOrgSelected);
    };

    // Chuyển đổi dữ liệu cây thành dữ liệu phẳng với chỉ số hàng
    const flattenTreeData = (data) => {
        const result = [];
        let index = 0;

        const traverse = (nodes) => {
            nodes.forEach((node) => {
                result.push({ ...node, index });
                index += 1;
                if (node.children) {
                    traverse(node.children);
                }
            });
        };

        traverse(data);
        return result;
    };

    const handleChangePlanPeriod = (value) => {
        dispatch(reset())
        dispatch(getSelectBox(value));
        form.setFieldsValue({ categoryReportId: undefined });
    }

    const handleChangeCategoryReport = (value, record) => {
        setCategoryReportType(record.type)
    }

    return (
        <Modal
            width={1300}
            open={isOpen}
            footer={null}
            onCancel={() => {
                handleClose();
            }}
        >
            <Spin spinning={isLoading} delay={300}>
                <Container className="form">
                    <Title level={3}>XUẤT FILE BÁO CÁO</Title>
                    <Form size="large" form={form} initialValues={{ orgs: [{}] }} onFinish={handleSubmit} layout="vertical">
                        <Row className='w-100'>
                            <Col md={4}>
                                <Form.Item name={'planPeriodId'} label={'Kỳ kế hoạch'}>
                                    <Select
                                        className="w-100"
                                        showSearch
                                        options={planPeriodList.map(x => {
                                            return {
                                                value: x.id,
                                                label: x.name,
                                            };
                                        })}
                                        onChange={handleChangePlanPeriod}
                                        filterOption={filterOption}
                                        placeholder="Chọn kỳ kế hoạch"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={1} />
                            <Col md={13}>
                                <Form.Item name={'categoryReportId'} rules={[{ required: true, message: 'Vui lòng chọn' }]} label={'Tên báo cáo'}>
                                    <Select filterOption={filterOption} onChange={handleChangeCategoryReport} showSearch size='large' options={categoryReportList} placeholder="loại báo cáo" />
                                </Form.Item>
                            </Col>
                            <Col md={1} />
                            <Col md={5}>
                                <Form.Item initialValue={1} rules={[{ required: true, message: 'Vui lòng chọn' }]} name={'exportExtensionType'} label={'Định dạng báo cáo'}>
                                    <Select size='large' options={formatTypes} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.List name="orgs">
                            {(fields) => (
                                <div style={{ display: 'flex', rowGap: 16, flexDirection: 'column' }}>
                                    {fields.map((field, index) => {
                                        return (
                                            <Table key={index} scroll={{ y: '60vh' }} rowSelection={rowSelection} bordered dataSource={tree} pagination={false} columns={columns} />
                                        );
                                    })}
                                </div>
                            )}
                        </Form.List>
                        <Form.Item>
                            <Row className="action mt-3" justify="end">
                                <Col>
                                    <Button type="primary" htmlType="submit" disabled={false}>
                                        Xuất File
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        onClick={() => {
                                            handleClose();
                                        }}
                                    >
                                        Hủy
                                    </Button>
                                </Col>

                            </Row>
                        </Form.Item>
                    </Form>
                </Container>
            </Spin>
        </Modal >
    );
};

export default ExportExcelComponent;
